import { ErrorContent } from 'utils/api';

export const enum ModalName {
  addReasonSuccessToast = 'addReasonSuccessToast',
  addReasonErrorAlert = 'addReasonErrorAlert',
  addShift = 'addShift',
  addShiftErrorAlert = 'addShiftErrorAlert',
  deleteShiftErrorAlert = 'deleteShiftErrorAlert',
  addShiftSuccessToast = 'addShiftSuccessToast',
  closeWeek = 'closeWeek',
  closeWeekSuccessToast = 'closeWeekSuccessToast',
  closeWeekErrorAlert = 'closeWeekErrorAlert',
  copyTextSuccessToast = 'copyTextSuccessToast',
  deleteShift = 'deleteShift',
  deleteShiftSuccessToast = 'deleteShiftSuccessToast',
  deleteReason = 'deleteReason',
  deleteReasonSuccessToast = 'deleteReasonSuccessToast',
  deleteReasonErrorAlert = 'deleteReasonErrorAlert',
  formUnsavedChanges = 'formUnsavedChanges',
  addReason = 'addReason',
  logout = 'logout'
}

export interface MetaData {
  error: ErrorContent;
}

interface Modal {
  name: ModalName;
  isOpen: boolean;
  meta?: MetaData;
}

export type ModalState = Partial<Record<ModalName, Modal>>;

export interface ModalContextState {
  state: ModalState;
  open: (name: ModalName, meta?: MetaData) => void;
  close: (name: ModalName) => void;
  isModalOpen: (name: ModalName) => boolean;
}

export const enum ModalActionType {
  open = 'open',
  close = 'close'
}

export interface ModalAction {
  type: ModalActionType;
  payload: { modalName: ModalName; meta?: MetaData };
}
